import React, { Component } from 'react';
import './Home.css';
import ReactTypingEffect from 'react-typing-effect';
import '../Assets/font-awesome/css/font-awesome.css';
import NET from 'vanta/dist/vanta.net.min'
import * as THREE from 'three'
import DarkModeToggle from '../Dark/DarkModeToggle';
import '../Dark/styles.scss';

class Home extends Component {
  constructor() {
    super()
    this.vantaRef = React.createRef()
  }
  componentDidMount() {
    this.vantaEffect = NET({
      el: this.vantaRef.current,
      THREE: THREE
    })
  }
  componentWillUnmount() {
    if (this.vantaEffect) this.vantaEffect.destroy()
  }
   state= {
      data : {
         main : {
            "social":[
               {
                 "name":"facebook",
                 "url":"https://www.facebook.com/zaryab.mohammad.37201/",
                 "className" : "fa fa-facebook"
               },
              
               
               {
                 "name":"linkedin",
                 "url":"https://www.linkedin.com/in/mohammad-zaryab-52a190173/",
                 "className":"fa fa-linkedin"
               },
               {
                 "name":"instagram",
                 "url":"http://instagram.com/mohdzaryab/",
                 "className":"fa fa-instagram"
               },
               {
                 "name":"github",
                 "url":"http://github.com/mohdzaryab",
                 "className":"fa fa-github"
               },
               {
                 "name":"skype",
                 "url":"https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=mohammadzaryab0@gmail.com",
                 "className":"fa fa-envelope"
               }
             ]
           },


      }
   }
   

  render() {
   var networks= this.state.data.main.social.map(function(network){
      return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
    })
    return (
      
      <section id="home" ref={this.vantaRef}>
     
        <div className="TitleH" >HOME</div>
        <header id="home" >
        
          
<div className="row banner">
  
         <div className="banner-text">
            <h1 className="responsive-headline">
            <ReactTypingEffect
            staticText= "Hello! I am"
            text={["Mohammad Zaryab.", "a Web Developer."]}
            speed= {100}
            eraseDelay= {1000}
            typingDelay= {1000}
         />
            </h1>
            <h3>Developing Beautiful & Fast Websites using React.js</h3>
            <hr />
            <ul className="social">
            {networks}
            </ul>
         </div>
      </div>

      <p className="scrolldown"> 
         <a className="arrow" href="#About"></a>
         
      </p>
   </header>
   </section>
   
   
    );
  }
}

export default Home;